import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {CbiService, GenericOption, WorkType, WorkTypeService} from '@cas-hub/acabim-common-client';
import {WorkTypeTable} from '../../work-order.model';

@Component({
  selector: 'acabim-admin-work-order-type-details',
  templateUrl: './work-order-type-details.component.html',
  styleUrls: ['./work-order-type-details.component.scss']
})
export class WorkOrderTypeDetailsComponent implements OnInit {

  @Input() set workTypeData(value: any) {
    this.tabIndex = 0;
    this.showDone = false;
    if (value) {
      this.workTypeDetails = value;
    }
    this.init();
  }
  @Output() completed = new EventEmitter<any>();
  @Output() cancelled = new EventEmitter<any>();

  cbiGroupOptions: GenericOption[] = [];
  isLoading = false;
  parcel: WorkType | null = null;
  showDone = false;
  tabIndex = 0;
  viewStatus = 'add';
  workTypeDetails: WorkTypeTable | null = null;
  editForm: FormGroup = new FormGroup({
    name: new FormControl(),
    cbiGroup: new FormControl(),
    omniclass: new FormControl(),
    status: new FormControl(1),
  });
  statusOptions: GenericOption[] = [
    {label: 'Active', value: 1},
    {label: 'Archive', value: 0},
  ];

  constructor(
      private readonly cbiService: CbiService,
      private readonly workTypeService: WorkTypeService
  ) { }

  ngOnInit(): void {}

  init(): void {
    this.isLoading = true;
    this.cbiService.getGroups().subscribe(groups => {
      this.cbiGroupOptions = [];
      groups.map(group => {
        this.cbiGroupOptions.push({ label: group.id + ' – ' + group.name, value: group.id});
      });
      this.initForm();
    });
  }


  initForm(): void {
    if (this.workTypeDetails && this.editForm) {
      this.editForm.get('name')?.setValue(this.workTypeDetails.name);
      this.editForm.get('cbiGroup')?.setValue(this.workTypeDetails.cbi_group?.id);
      this.editForm.get('omniclass')?.setValue(this.workTypeDetails.omniclass);
      if (this.workTypeDetails.status && this.workTypeDetails.status > 0) {
        this.editForm.get('status')?.setValue(1);
      } else {
        this.editForm.get('status')?.setValue(0);
      }
      this.viewStatus = 'edit';
    }
    this.isLoading = false;
  }

  resetEditForm(): void {
    if (this.editForm) {
      this.editForm.get('name')?.setValue('');
      this.editForm.get('cbiGroup')?.setValue(null);
      this.editForm.get('omniclass')?.setValue('');
    }
  }

  cancel(): void {
    this.cancelled.emit(false);
  }
  close(): void {
    this.completed.emit(true);
    this.showDone = false;
    this.resetEditForm();
  }

  add(): void {
    this.gather();
    if (this.parcel) {
      this.isLoading = true;
      this.workTypeService.addWorkType(this.parcel).subscribe(data => {
        this.isLoading = false;
        this.showDone = true;
      }, error => {
        this.isLoading = false;
      });
    }
  }

  update(): void {
    this.gather();
    if (this.parcel && this.workTypeDetails && this.workTypeDetails.id) {
      this.isLoading = true;
      this.workTypeService.updateWorkType(this.workTypeDetails.id, this.parcel).subscribe(data => {
        this.isLoading = false;
        this.showDone = true;
      }, error => {
        this.isLoading = false;
      });
    }
  }

  gather(): void {
    if( this.editForm) {
      this.parcel = {
        name: this.editForm.get('name')?.value,
        cbi_group_id: this.editForm.get('cbiGroup')?.value,
        omniclass: this.editForm.get('omniclass')?.value,
        status: this.viewStatus === 'add' ? 1 : this.editForm.get('status')?.value
      };
    }
  }

  selectTab(value: any): void {
    this.tabIndex = value.id;
  }

} // end of class
